// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * core-service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NewBanksDiscoveryAPIModel
 */
export interface NewBanksDiscoveryAPIModel {
    /**
     * 
     * @type {string}
     * @memberof NewBanksDiscoveryAPIModel
     */
    phone: string;
    /**
     * 
     * @type {number}
     * @memberof NewBanksDiscoveryAPIModel
     */
    accountId?: number;
}

export function NewBanksDiscoveryAPIModelFromJSON(json: any): NewBanksDiscoveryAPIModel {
    return NewBanksDiscoveryAPIModelFromJSONTyped(json, false);
}

export function NewBanksDiscoveryAPIModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewBanksDiscoveryAPIModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'phone': json['phone'],
        'accountId': !exists(json, 'accountId') ? undefined : json['accountId'],
    };
}

export function NewBanksDiscoveryAPIModelToJSON(value?: NewBanksDiscoveryAPIModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'phone': value.phone,
        'accountId': value.accountId,
    };
}


